import * as apis from '@/apis/cart';
import * as actions from '@/actions';
import { call, put, takeLatest, select } from 'redux-saga/effects';

export const getAuth = (state) => state.auth;
export const getCartList = (state) => state.cart.cartList;
import {
  CART_GET_CART_LIST_REQUEST,
  CART_APPLY_ORDER_DETAILS,
  CART_DELETE_CARTS_REQUEST
} from '../../actions/cart/actionTypes';
import { CartApplyOrderDetails, ICartDeleteRequest } from '@/actions/cart/models/types';

function* fetchCartList() {
  try {
    const auth = yield select(getAuth);
    const { userInfo, currentAccount } = auth;
    const result = yield call(apis.requestCartList, userInfo, currentAccount);
    yield put(actions.getCartList.success(result.data));
  } catch (error) {
    yield put(actions.getCartList.failure(error));
  }
}

function* applyOrderDetails({ orderDetails, callback }: CartApplyOrderDetails) {
  yield put(actions.createNewOrder.request(orderDetails));
  yield call(callback);
}

function* deleteCarts({ cartIdList }: ICartDeleteRequest) {
  try {
    const cartList = yield select(getCartList);
    yield call(apis.requestDeleteCart, cartIdList);
    const newCartList = cartList.map((item) => {
      const cart = { ...item };
      if (cartIdList.includes(cart.shoppingCartId)) {
        //mark deletedCart as deleted(for zoom out animation purpose)
        cart.deleted = true;
      }
      return cart;
    });
    yield put(actions.deleteCarts.success(newCartList, cartIdList.length));
  } catch (error) {
    yield put(actions.deleteCarts.failure(error));
  }
}

export default function* newlineSagas() {
  yield takeLatest(CART_GET_CART_LIST_REQUEST, fetchCartList);
  yield takeLatest(CART_APPLY_ORDER_DETAILS, applyOrderDetails);
  yield takeLatest(CART_DELETE_CARTS_REQUEST, deleteCarts);
}
